import Parse from "parse";

import type { Ticket } from "./Ticket";
import type { _User } from "./_User";

export interface OrderAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description?: string;
  tickets: Parse.Relation<Order, Ticket>;
  title: string;
  user: _User;
}

export class Order extends Parse.Object<OrderAttributes> {
  static className: string = "OD3_Maintenance_Order";

  constructor(data?: Partial<OrderAttributes>) {
    super("OD3_Maintenance_Order", data as OrderAttributes);
  }

  get description(): string | undefined {
    return super.get("description");
  }
  set description(value: string | undefined) {
    super.set("description", value);
  }
  get tickets(): Parse.Relation<Order, Ticket> {
    return super.relation("tickets");
  }
  get title(): string {
    return super.get("title");
  }
  set title(value: string) {
    super.set("title", value);
  }
  get user(): _User {
    return super.get("user");
  }
  set user(value: _User) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Order", Order);
